import { useState, useEffect } from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { useInView } from 'react-intersection-observer';

function Counter({ end, suffix = '', duration = 2000, light = false }) {
  const [count, setCount] = useState(0);
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.5 });

  useEffect(() => {
    if (!inView) return;
    let start = 0;
    const increment = end / (duration / 16);
    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [inView, end, duration]);

  return (
    <Typography
      ref={ref}
      variant="h2"
      sx={{
        background: light
          ? 'linear-gradient(135deg, #E8DEC3 0%, #D1BC8A 100%)'
          : 'linear-gradient(135deg, #D1BC8A 0%, #B8A06E 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        fontWeight: 800,
        position: 'relative',
        display: 'inline-block',
      }}
    >
      {count}
      {suffix}
    </Typography>
  );
}

const defaultStats = [
  { value: 150, suffix: '+', label: 'Projekte realisiert' },
  { value: 15, suffix: '+', label: 'Jahre Erfahrung' },
  { value: 30, suffix: '+', label: 'Mitarbeiter' },
  { value: 100, suffix: '%', label: 'Kundenzufriedenheit' },
];

export default function StatsCounter({ light = false, items }) {
  const stats = items && items.length > 0 ? items : defaultStats;
  return (
    <Grid container spacing={4}>
      {stats.map((stat, i) => (
        <Grid size={{ xs: 6, md: 3 }} key={i}>
          <Box
            sx={{
              textAlign: 'center',
              p: 3,
              borderRadius: 3,
              background: light
                ? 'linear-gradient(135deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.02) 100%)'
                : 'linear-gradient(135deg, rgba(209, 188, 138, 0.08) 0%, rgba(209, 188, 138, 0.03) 100%)',
              backdropFilter: light ? 'blur(10px)' : 'none',
              border: `1px solid ${light ? 'rgba(255,255,255,0.1)' : 'rgba(209, 188, 138, 0.15)'}`,
              transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
              '&:hover': {
                transform: 'translateY(-4px)',
                background: light
                  ? 'linear-gradient(135deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.04) 100%)'
                  : 'linear-gradient(135deg, rgba(209, 188, 138, 0.12) 0%, rgba(209, 188, 138, 0.06) 100%)',
                boxShadow: light
                  ? '0 12px 32px rgba(0, 0, 0, 0.2)'
                  : '0 12px 32px rgba(209, 188, 138, 0.15)',
              },
            }}
          >
            <Counter end={Number(stat.value)} suffix={stat.suffix} light={light} />
            <Typography
              variant="body1"
              sx={{
                mt: 1.5,
                color: light ? 'rgba(255,255,255,0.8)' : 'text.secondary',
                fontWeight: 600,
                fontSize: '0.95rem',
              }}
            >
              {stat.label}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
}
